import React from 'react';
import PropTypes from 'prop-types';
import Question from '../components/Question';
import QuestionCount from '../components/QuestionCount';
import AnswerOption from '../components/AnswerOption';
import { CSSTransitionGroup } from 'react-transition-group';

function Quiz(props) {
    function renderAnswerOptions(key) {
        return (
          <AnswerOption
            key={key.content}
            answerContent={key.content}
            answerType={key.type}
            answer={props.answer}
            value={key.value}
            questionId={props.questionId}
            onAnswerSelected={props.onAnswerSelected}
          />
        );
      }
    return ( 
      <CSSTransitionGroup
      className="container"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={2000}
      transitionLeaveTimeout={1500}
      transitionAppear
      transitionAppearTimeout={1500}
      >
      <div className={"container-btn question-container question" + props.questionId + "-background"}>
          <div className="row questionmargin">
              <div className="col-4 col-md-3 question-circle__col">
                  <span className="question-circle text-center">Q{props.questionId}</span>
              </div>
              <div className="col-8 col-md-9">
                  <span className="question-heading">
                    <Question content={props.question} />
                  </span>
              </div>
          </div>

          <div className="skintone-shade">
              <div className="row questionmargin-row">
                {props.answerOptions.map(renderAnswerOptions)}
              </div>
          </div>
      </div>
      </CSSTransitionGroup>
    );
  }
  
  Quiz.propTypes = {
    answer: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    answerOptions: PropTypes.array.isRequired,
    question: PropTypes.string.isRequired,
    questionId: PropTypes.number.isRequired,
    questionTotal: PropTypes.number.isRequired,
    onAnswerSelected: PropTypes.func.isRequired,
    onBackQuizSelected: PropTypes.func.isRequired
  };
  
  export default Quiz;